import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";

import ActionsCell from "./ActionsCell";
import DataGridDateCell from "../../molecules/DataGridDateCell";
import DataGridTextCell from "../../molecules/DataGridTextCell";
import DataGridTextHeader from "../../molecules/DataGridTextHeader";
import StatusChip from "../../molecules/StatusChip";

/**
 * Some dates are missing zero-padding.
 * Ensure consistent format across dates.
 */
export const normalizeDateValue = (value: string) => {
  const [day, month, year] = value.split("/");
  return [day.padStart(2, "0"), month.padStart(2, "0"), year].join("/");
};

const columns: GridColDef[] = [
  {
    field: "productId",
    headerName: "Product ID",
    width: 120,
    renderCell: DataGridTextCell,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "productName",
    headerName: "Name",
    width: 220,
    renderCell: DataGridTextCell,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "productType",
    headerName: "Type",
    width: 220,
    valueFormatter: ({ value }) => value && value.replaceAll("_", " "),
    renderCell: DataGridTextCell,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "startDate",
    headerName: "Start Date",
    width: 130,
    valueGetter: ({ value }) =>
      value && dayjs(normalizeDateValue(value), "DD/MM/YYYY"),
    renderCell: DataGridDateCell,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "expirationDate",
    headerName: "End Date",
    width: 130,
    valueGetter: ({ value }) =>
      value && dayjs(normalizeDateValue(value), "DD/MM/YYYY"),
    renderCell: DataGridDateCell,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "quantity",
    headerName: "Remaining Inventory",
    width: 190,
    renderCell: DataGridTextCell,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "voucherExpirationDate",
    headerName: "Earliest Expiry Date",
    width: 190,
    valueGetter: ({ value }) =>
      value && dayjs(normalizeDateValue(value), "DD/MM/YYYY"),
    renderCell: DataGridDateCell,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "expiryCount",
    headerName: "Earliest Expiry Count",
    width: 190,
    renderCell: DataGridTextCell,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    renderCell: StatusChip,
    renderHeader: DataGridTextHeader,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 400,
    valueGetter: item => ({
      status: item.row.status,
      id: item.row.productId,
      name: item.row.productName,
    }),
    renderCell: ActionsCell,
    renderHeader: DataGridTextHeader,
    sortable: false,
    filterable: false,
    align: "right",
    headerAlign: "right",
  },
];

export default columns;
